import { render, staticRenderFns } from "./RecetteCard.vue?vue&type=template&id=c85bb8f6&scoped=true"
import script from "./RecetteCard.vue?vue&type=script&lang=js"
export * from "./RecetteCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c85bb8f6",
  null
  
)

export default component.exports